"use client";

import React from "react";
import { BiEnvelope, BiMap, BiPhone } from "react-icons/bi";
import { useStaggeredAnimation } from "@/hooks/useScrollAnimation";

export function HomeContact() {
  const [ref, visibleItems] = useStaggeredAnimation(3, 200);

  return (
    <section id="relume" className="px-[5%] py-10 md:py-16 lg:py-24 bg-gray-900">
      <div className="container mx-auto">
        <div ref={ref} className="grid auto-cols-fr grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-8 md:gap-y-10 justify-center items-center">
          <div className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${
            visibleItems.has(0) 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            <div className="mb-3 lg:mb-4">
              <BiEnvelope className="size-8 text-white" />
            </div>
            <h2 className="mb-2 text-2xl leading-[1.3] font-bold md:text-xl lg:mb-2 lg:text-2xl text-white">
              Correo
            </h2>
            <p className="mb-3 md:mb-4 text-sm text-gray-300">
              Contáctanos para cualquier consulta o información adicional sobre nuestros vehículos.
            </p>
            <a className="underline text-sm text-white hover:text-gray-300 transition-colors" href="mailto:contacto@vehiculosndc.com">
              contacto@vehiculosndc.com
            </a>
          </div>
          <div className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${
            visibleItems.has(1) 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            <div className="mb-3 lg:mb-4">
              <BiPhone className="size-8 text-white" />
            </div>
            <h3 className="mb-2 text-lg leading-[1.3] font-bold md:text-xl lg:mb-2 lg:text-2xl text-white">
              Teléfono
            </h3>
            <p className="mb-3 md:mb-4 text-sm text-gray-300">
              Estamos disponibles para atender tus llamadas y resolver tus dudas.
            </p>
            <a className="underline text-sm text-white hover:text-gray-300 transition-colors" href="tel:+18095655152">
              (809) 565-5152
            </a>
          </div>
          <div className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${
            visibleItems.has(2) 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            <div className="mb-3 lg:mb-4">
              <BiMap className="size-8 text-white" />
            </div>
            <h3 className="mb-2 text-lg leading-[1.3] font-bold md:text-xl lg:mb-2 lg:text-2xl text-white">
              Oficina
            </h3>
            <p className="mb-3 md:mb-4 text-sm text-gray-300">
              Visítanos en nuestra sede para una atención personalizada.
            </p>
            <a className="underline text-sm text-white hover:text-gray-300 transition-colors" href="https://maps.google.com" target="_blank" rel="noopener noreferrer">
              Av. José Núñez de Cáceres 804, Santo Domingo, RD
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
